<template>
  <Card v-if="hasApplicationBundles" size="large">
    <View gap="md" direction="column">
      <Text variant="h4">{{ pluralize('Application', applicationBundles.length) }}</Text>

      <View gap="lg" direction="column">
        <RenterProfileApplicationPreviewWidget
          v-for="applicationBundle in applicationBundles"
          :key="applicationBundle.id"
          :application-bundle="applicationBundle"
        />
      </View>
    </View>
  </Card>
</template>

<script setup lang="ts">
import pluralize from 'pluralize';
import { computed } from 'vue';

import { Card, Text, View } from '@tallo/design-system';

import { useRenterProfileStore } from '../store/renter-profile.store';
import RenterProfileApplicationPreviewWidget from './renter-profile-application-preview-widget.vue';

const renterProfileStore = useRenterProfileStore();
const applicationBundles = computed(() => renterProfileStore.getApplicationBundles);
const hasApplicationBundles = computed(() => renterProfileStore.hasApplicationBundles);
</script>

<style scoped lang="scss"></style>
